import { QuestionBase } from "./question-base.model";

export class TextboxQuestion extends QuestionBase<string> {
  controlType = 'textbox';
  type: string;
  placeholder: string;
  maxlength: string;
  minlength: string;
  macro_datasource: any;
  pattern: string;
  trim: boolean; // Not in use
  disabled: boolean;
  asyncValidation: any;
  visible: string;
  searchable: boolean;
  formAutofill: any;
  cstm_error_msg:any;
  conditions: any=[];
  textCapitalize: boolean;
  asideButton: any;
  text_buttonIcon: any;
  additional_space: boolean;
  
  constructor(options: {} = {}) {
    super(options);
    this.type = options['type'] || '';
    this.placeholder = options['placeholder'] || '';
    this.macro_datasource =  (options['macro_datasource'] == undefined) ? false : options['macro_datasource'];
    this.maxlength = options['maxlength'] || '';
    this.minlength = options['minlength'] || '';
    this.pattern = options['pattern'] || '';
    this.trim = options['trim'] || ''; // Not in use
    this.disabled = options['disabled'] || '';
    this.asyncValidation = options['asyncValidation'] || null;
    this.visible = (options['visible'] == undefined) ? true : options['visible'];
    this.searchable = (options['searchable'] == undefined) ? false : options['searchable'];
    this.formAutofill = options['formAutofill'];
    this.cstm_error_msg = options['cstm_error_msg'];
    this.conditions = options['conditions'];
    this.textCapitalize = (options['textCapitalize'] == undefined) ? false : options['textCapitalize'];
    this.asideButton = options['asideButton'] || false;
    this.text_buttonIcon = options['text_buttonIcon'];
    this.additional_space = (options['additional_space'] == undefined) ? false : options['additional_space'];
  }
}
